var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-wrapper"},[_c('h5',{staticClass:"c-title"},[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),_c('div',{staticClass:"c-cont-wrap"},_vm._l((_vm.data.list),function(item,index){return _c('p',{key:index,staticClass:"c-wrap-row"},[_c('b',[_vm._v(_vm._s(item.name))]),_vm._v(_vm._s(item.desc))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0087d4fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cell-glossary.vue
// module id = null
// module chunks = 